import * as React from "react";
const SvgX = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18 6L6 18M6 6L18 18", stroke: "black", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgX;
